import Request from "./index";
import { Routes } from "../constant/api_url";

const getPrimeProductList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEPRODUCTLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Accepts FormData so p_image can be uploaded.
const insertPrimeProduct = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMEPRODUCT, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" })
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeProduct = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMEPRODUCT, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" })
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeProductStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMEPRODUCTSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Accepts FormData so a stock-in receipt can be uploaded.
const insertPrimeStockInData = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMESTOCKINDATA, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" })
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeStockHistory = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMESTOCKHISTORY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimePinMemberList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEPINMEMBERLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMemberAllAssignData = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEMEMBERALLASSIGNDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Returns whether the member is on the free path or must purchase.
const getPrimeMemberAssignEligibility = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEMEMBERASSIGNELIGIBILITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// First award of a pin - free.
const assignPrimeProductToMember = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNPRIMEPRODUCTTOMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Guest assign - a guest is not a member, so there is no free/purchase gate.
const assignPrimeProductToGuest = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNPRIMEPRODUCTTOGUEST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Member already holds the pin and is buying it again.
const purchasePrimeProductToMember = async (data) => {
  try {
    const result = await Request.post(Routes.PURCHASEPRIMEPRODUCTTOMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const revokePrimeProductFromMember = async (data) => {
  try {
    const result = await Request.post(Routes.REVOKEDPRIMEPRODUCTFROMMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const disablePrimeMemberEligibility = async (data) => {
  try {
    const result = await Request.post(Routes.DISABLEPRIMEMEMBERELIGIBILITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeAchievementPinList = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEACHIEVEMENTPINLIST);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const primeStockOutSendType = async (data) => {
  try {
    const result = await Request.post(Routes.PRIMESTOCKSENDTYPE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeStockInData = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMESTOCKINDATA, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" })
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeStockProductList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMESTOCKPRODUCTLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimePinReportByMember = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEPINREPORTBYMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

export {
  primeStockOutSendType,
  updatePrimeStockInData,
  getPrimeStockProductList,
  getPrimePinReportByMember,
  getPrimeProductList,
  insertPrimeProduct,
  updatePrimeProduct,
  updatePrimeProductStatus,
  insertPrimeStockInData,
  getPrimeStockHistory,
  getPrimePinMemberList,
  getPrimeMemberAllAssignData,
  getPrimeMemberAssignEligibility,
  assignPrimeProductToMember,
  assignPrimeProductToGuest,
  purchasePrimeProductToMember,
  revokePrimeProductFromMember,
  disablePrimeMemberEligibility,
  getPrimeAchievementPinList
};
